export const API_ENDPOINTS = {
  List: 'report/services-products',
  Details: 'report/services-products/details',
};
